import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AccountService } from '@app/_services';
import { NavController, Platform } from '@ionic/angular';
import { UtilsService } from 'abp-ng2-module/dist/src/utils/utils.service';
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private accountService: AccountService,
        private _utilService: UtilsService,
        private platform: Platform,
        private navCtrl: NavController
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const loggedInUser = this.accountService.userLoggedIn;
        if (loggedInUser) {
            // authorised so return true
            // if(this.platform.is('mobile')){
            //     console.log('navigate mobile');
            //     this.navCtrl.navigateRoot('/credit-union-list');
            //     // return false;
            //     // this.router.navigate(['/credit-union-list']);
            // }
            return true;
        }
        // not logged in so redirect to login page with the return url
        // if (this.platform.is('mobile') && !this.platform.is('mobileweb')) {
        //     if (window.localStorage.getItem('MobileLocation') != null && window.localStorage.getItem('MobileLocation').toLowerCase() == 'ke') {
        //         this.router.navigate(['/account/registeruser'], { queryParams: {} });
        //     } else {
        //         this.router.navigate(['/account/login'], { queryParams: {} });
        //     }
        // } else {
        //     this.router.navigate(['/account/login'], { queryParams: {} });
        // }
        
        this.router.navigate(['/account/login'], { queryParams: {} });
        return false;
    }
}
